import { Backdrop, Box, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { isNil } from "lodash";
import { useNavigate, useSearchParams } from "react-router-dom";
import CircleLoader from "react-spinners/CircleLoader";
import { useAppContext } from "../app/AppContextProvider";
import BaseTextField from "../components/base/BaseTextField";
import { LoginDto, useMutationLogin } from "./AuthentificationQuery";
interface LoginProps {
}
const Login = (props: LoginProps) => {


    let [params] = useSearchParams()

    let url = params.get("url")
    let navigate = useNavigate()
    let log = useMutationLogin();

    let context = useAppContext();

    const onSubmit = async (values: LoginDto) => {

        let appUser = await log.mutateAsync(values);

        await context.login(appUser);


        if (!isNil(url))
            navigate(url, {
                replace: true
            })
        else
            navigate("/ootr/tricks", {
                replace: true
            })
    }

    return <Backdrop open sx={{ zIndex: 99999 }}>
        <Box className="loginForm">
            <Formik<LoginDto>
                onSubmit={async (values) => await onSubmit(values)}
                initialValues={{
                    username: "",
                    password: ""
                }}
            >
                {({ values, setFieldValue }) => {

                    return <Form>
                        <Grid container>
                            <Grid item xs={12}>
                                <Box component="h3">Login Here</Box>
                            </Grid>
                            <Grid item xs={12}>
                                <label>Username</label>
                            </Grid>
                            <Grid item xs={12}>
                                <BaseTextField value={values.username} onChange={(v) => setFieldValue("username", v.currentTarget.value)} />
                            </Grid>
                            <Grid item xs={12}>
                                <label>Password</label>
                            </Grid>
                            <Grid item xs={12}>
                                <BaseTextField type="password" value={values.password} onChange={(v) => setFieldValue("password", v.currentTarget.value)} />
                            </Grid>
                            <Grid item xs={12} justifyContent="center">
                                {!log.isLoading && <button type="submit">Login</button>}
                                {log.isLoading && <Box display="flex" justifyContent={"center"} sx={{ marginTop: "20px" }}><CircleLoader /></Box>}
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </Box>
    </Backdrop>

}

export default Login